
const Search = {
  init() {
    Search.initSearch();
  },

  initSearch() {
    // Debounced search on input activity
    const debouncedSearch = debounce(function () {
      let searchString = $('.searchRegion input').val();
      Search.submitSearch(searchString);
    }, 500);

    $('.searchRegion input').on('input', debouncedSearch);

    // Debounce function
    function debounce(func, wait) {
      let timeout;
      return function (...args) {
        const context = this;
        clearTimeout(timeout);
        timeout = setTimeout(() => func.apply(context, args), wait);
      };
    }
  },

  submitSearch(searchString) {

    // Check if search string is empty
    if (searchString === "" || searchString.length < 2) {
      $(".searchRegion__results").addClass("hidden");
      return;
    };

    $(".searchRegion__results")
      .removeClass("hidden")
      .html('<div class="searchRegion__loader"></div>');

    // Submit search form
    $.ajax({
      url: ajaxurl,
      type: 'POST',
      data: {
        action: 'region_search',
        search: searchString,
      },
    }).done((response) => {

      if (response.success) {
        $(".searchRegion__results").html(response.data);
      } else {
        $(".searchRegion__results")
          .removeClass("hidden")
          .html(response.data);
      }
    })
  }

};

export default Search;
